// extracted by mini-css-extract-plugin
export var animationContainer = "_cd-0";
export var asteriskIcon = "_cd-8";
export var conversationLeftSection = "_cd-4";
export var conversationListItem = "_cd-3";
export var conversationMiddleSection = "_cd-5";
export var conversationRightSection = "_cd-6";
export var detailsContent = "_cd-1";
export var listContainer = "_cd-7";
export var modalContent = "_cd-2";